import { render, staticRenderFns } from "./BoardPostBaseCreate.vue?vue&type=template&id=663191f9&scoped=true"
import script from "./BoardPostBaseCreate.vue?vue&type=script&lang=js"
export * from "./BoardPostBaseCreate.vue?vue&type=script&lang=js"
import style0 from "./BoardPostBaseCreate.vue?vue&type=style&index=0&id=663191f9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663191f9",
  null
  
)

export default component.exports